export enum UserAccountStorage {
  SelectedLanguage = 'selectedLng',
  LastSync = 'lastSyncTime',
  Version = 'version',
  DbVersion = 'dbVersion',
  DontShowAgainCloseModal = 'closeModal',
  DontShowAgainCloseModalPrice = 'closeModalPrice',
  DontShowAgainWidgetInfo = 'widgetInfo',
  DontShowAgainEmployeesInfo = 'employeesInfo',
  DontShowAgainEmployeesIntegrationInfo = 'employeesIntegrationInfo',
  DontShowAgainICalendarInfo = 'IcalendarInfo',
  DontShowAgainBookingInfo = 'BookingInfo',
  DontShowAgainBookingReservationModal = 'bookingReservationModal',
  DontShowAgainCloseModalEmployee = 'EmployeeCloseModal',
  SetOnbordingModal = 'hideOnbordingModal',
}

export enum CredentialsStorage {
  AccessToken = 'accessToken',
  UserID = 'userId',
}

export enum CurrencyStorage {
  Currencies = 'currencies',
  LastSync = 'currencyLastSyncTime',
}

export enum RoomsFiltering {
  Options = 'roomsFilteringOptions',
}

export const ReservationForm = {
  FieldVisibility: 'reservationFormFieldVisibility',
  createFieldName: fieldName => `reservationFormFieldVisibility.${fieldName}`,
}

export default {
  CredentialsStorage,
  ReservationForm,
  RoomsFiltering,
  UserAccountStorage,
  CurrencyStorage,
}
